import React from 'react';
import { Bottom, First, Left, Main, Right, Square, Top } from './styles';

export default function ApiKeyLoading() {
  return (
    <Main>
      <First>
        <Left>
          <Top className='loading-animation' />
          <Bottom className='loading-animation' />
        </Left>
        <Right>
          <Square className='loading-animation' />
          <Square className='loading-animation' />
        </Right>
      </First>
      <First>
        <Left>
          <Top className='loading-animation' />
          <Bottom className='loading-animation' />
        </Left>
        <Right>
          <Square className='loading-animation' />
          <Square className='loading-animation' />
        </Right>
      </First>
      <First>
        <Left>
          <Top className='loading-animation' />
          <Bottom className='loading-animation' />
        </Left>
        <Right>
          <Square className='loading-animation' />
          <Square className='loading-animation' />
        </Right>
      </First>
      <First>
        <Left>
          <Top className='loading-animation' />
          <Bottom className='loading-animation' />
        </Left>
        <Right>
          <Square className='loading-animation' />
          <Square className='loading-animation' />
        </Right>
      </First>
      <First>
        <Left>
          <Top className='loading-animation' />
          <Bottom className='loading-animation' />
        </Left>
        <Right>
          <Square className='loading-animation' />
          <Square className='loading-animation' />
        </Right>
      </First>
    </Main>
  );
}
